import UserProfileSetting from './UserProfileSetting';

export default UserProfileSetting;
